import React from 'react';
import PropTypes from 'prop-types';
import { BrowserOnly, PrintOnly } from 'cccisd-laravel-report';
import PercentSmiley from './PercentSmiley';
import ShowValue from './ShowValue';
import style from './style.css';

const Callout = props => {
    const { title, description, colors } = props.settings;

    return (
        <div
            className={style.wrapper}
            style={
                colors
                    ? {
                          border: `1px solid ${colors.primary}`,
                      }
                    : {}
            }
        >
            <div
                className={style.title}
                style={
                    colors
                        ? {
                              backgroundColor: colors.primary,
                          }
                        : {}
                }
            >
                {title}
            </div>
            <div className={style.description} style={description ? { padding: '0.5em' } : {}}>
                {description}
            </div>
            <div className={style.component}>
                <BrowserOnly>
                    <PercentSmiley data={props.data} colors={colors} />
                </BrowserOnly>
                <PrintOnly>
                    <ShowValue data={props.data} colors={colors} />
                </PrintOnly>
            </div>
        </div>
    );
};

Callout.propTypes = {
    settings: PropTypes.object,
    handle: PropTypes.string,
    data: PropTypes.object,
};

Callout.defaultProps = {};

export default Callout;
